import React from 'react'
import styled from 'styled-components'
import { Field } from 'formik'

// Components
import CurrencyField from '../_components/form-fields/CurrencyField'

// Helpers
import { formatCurrency, formatIneligible } from '../_helpers'

const cellPaddingH = 10

export const StyledBBCFormRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-left: -${cellPaddingH}px;
  margin-right: -${cellPaddingH}px;

  .row-label,
  .last-value,
  .row-value {
    padding-left: ${cellPaddingH}px;
    padding-right: ${cellPaddingH}px;
    font-size: 18px;
  }

  .row-label {
    flex-grow: 1;
    flex-basis: 0;
    .required-asterix {
      color: red;
      padding-left: 2px;
    }
  }

  .inelegible-row-label {
    padding-left: 30px;
  }

  .last-value,
  .row-value {
    width: 195px;
  }

  .row-value {
    &.inelegible-row-value {
      position: relative;
      &:before,
      &:after {
        position: absolute;
        height: 100%;
        top: 0;
        display: flex;
        align-items: center;
        opacity: 0.4;
      }

      &:before {
        content: '(';
        left: ${cellPaddingH + 6}px; // pad left more
      }

      &:after {
        content: ')';
        right: ${cellPaddingH + 5}px;
      }
    }
  }

  .last-value,
  .totals-row-value {
    text-align: right;
  }

  input {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 16px;
    padding: 16px 8px;
    outline: none;
    &:not([type='date']) {
      text-align: right;
      &:focus {
        text-align: left;
      }
    }
  }
`

export const BBCFormRow = ({
  label,
  lastValue,
  value,
  fieldType = 'number',
  inputName,
  onChange = () => {},
  handleBlur = () => {},
  isIneligible = false,
  inputTestID = '',
  showLast = true,
}) => {
  return (
    <StyledBBCFormRow>
      <div className="row-label">
        {label}
        <span className="required-asterix">*</span>
      </div>
      {showLast && <div className="last-value">{lastValue}</div>}
      <div className={`row-value ${isIneligible ? 'inelegible-row-value' : ''}`}>
        {fieldType === 'number' && (
          <CurrencyField
            field={{
              required: true,
              value: value,
              defaultValue: value,
              type: fieldType,
            }}
            formikName={inputName}
            handleBlur={handleBlur}
            inputTestID={inputTestID}
            onChange={onChange}
          />
        )}
        {fieldType === 'date' && (
          <Field name={inputName} onBlur={handleBlur} onChange={onChange} required={true} type={'date'} value={value} />
        )}
      </div>
    </StyledBBCFormRow>
  )
}

export const BBCTotalsRow = ({ label, lastValue, value, isIneligible = false, showLast = true }) => (
  <StyledBBCFormRow>
    <div className={`row-label ${isIneligible ? 'inelegible-row-label' : ''}`}>{label}</div>
    {showLast && <div className="last-value">{lastValue}</div>}
    <div className="row-value totals-row-value">{value}</div>
  </StyledBBCFormRow>
)

export const BBCAssetFormRow = (props) => {
  const { id, last_value, last_date, date, value } = props.asset
  const { inputTestID = '', showLast } = props
  return (
    <div>
      <BBCFormRow
        fieldType={'date'}
        handleBlur={() => {
          props.handleBlur('asset', id, 'date', date)
        }}
        inputName={`asset-${id}-date`}
        label={'Report Date'}
        lastValue={new Date(last_date).toLocaleDateString()}
        onChange={props.onDateChange}
        showLast={showLast}
        value={date ? date.split('T')[0] : ''}
      />
      <BBCFormRow
        handleBlur={() => {
          props.handleBlur('asset', id, 'value', value)
        }}
        inputName={`asset-${id}`}
        inputTestID={inputTestID}
        label={props.label}
        lastValue={formatCurrency(last_value)}
        onChange={props.onValueChange}
        showLast={showLast}
        value={value}
      />
    </div>
  )
}

export const BBCIneligibleFormRow = (props) => {
  const { id, label, last_value, value } = props.ineligible
  return (
    <BBCFormRow
      handleBlur={() => {
        props.handleBlur('ineligible', id, 'value', value)
      }}
      inputName={`ineligible-${id}`}
      isIneligible={true}
      label={label}
      lastValue={formatIneligible(last_value)}
      onChange={props.onValueChange}
      showLast={props.showLast}
      value={value}
    />
  )
}
